import { request } from '@/network/request.js'

// 初始化玩家信息
export const initUser = () => {
  return request({
    url: '/m/ht/gashapon/initUser',
  });
}

// 绑定角色
export const saveRole = (params) => {
  return request({
    url: '/m/ht/gashapon/saveRole',
    params
  });
}

// 分享
export const share = () => {
  return request({
    url: '/m/ht/gashapon/share',
  });
}

// 扭蛋（抽奖）
export const lottery = () => {
  return request({
    url: '/m/ht/gashapon/lottery',
  });
}

// 领奖
export const getPrize = (params) => {
  return request({
    url: '/m/ht/gashapon/getPrize',
    params
  });
}

// 查看个人奖励信息
export const getUserPrizeList = () => {
  return request({
    url: '/m/ht/gashapon/getUserPrizeList',
  });
}

// 清理new标识头像id
export const clearNewIconIds = () => {
  return request({
    url: '/m/ht/gashapon/clearNewIconIds',
  });
}








